import React, { FC } from 'react';
import { View } from 'react-native';

import NCFileBatchEvents from '@v2/pages/common/components/NCFileBatchEvents';
import { NcFileBatchEventType } from '@v2/pages/common/enums';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';

import { useManageDashboardDrilldownNcFileBody } from './hooks/useManageDashboardDrilldownNcFileBody';

export interface DashboardDrilldownNcFileBodyProps {
  ncFileId: number;
}

const DashboardDrilldownNcFileBody: FC<DashboardDrilldownNcFileBodyProps> = ({ ncFileId }) => {
  const { startedOn, endedOn } = useManageDashboardDrilldownNcFileBody();

  return (
    <View testID={TEST_IDS.dashboardDrilldown.ncFileBatchEvents} style={{ flex: 1 }}>
      <NCFileBatchEvents eventType={NcFileBatchEventType.CYCLE} ncFileId={ncFileId} startedOn={startedOn} endedOn={endedOn} />
    </View>
  );
};

export default DashboardDrilldownNcFileBody;
